'use strict';

var get = require('lodash/get');

var ClientFactory = require('./client');
var keyParser = require('../utils/key/parser');

function FixKey(context) {
  var settings = context.get(context.constants.SETTINGS);
  var key = get(settings, 'core.key', undefined);

  if (settings.mode === 'localhost' && key === undefined) {
    settings.core.key = 'localhost_key';
  } else {
    keyParser(key);
  }

  var client = ClientFactory(context);
  // In the browser land, the key is required
  client.isBrowserClient = true;
  client.getTreatment = client.getTreatment.bind(client, settings.core.key);
  client.getTreatments = client.getTreatments.bind(client, settings.core.key);

  return client;
}

module.exports = FixKey;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/client/browser.js
// module id = 430
// module chunks = 11